import { TRANSFERS } from "./types";


const bankTransfer = (data, history) => ({
  type:   TRANSFERS.BANK_TRANSFER,
  payload: data,
  history
});

const bankTransferSuccess = (data) => ({
  type:   TRANSFERS.BANK_SUCCESS,
  payload: data,
});

const bankTransferFail = (data) => ({
  type:   TRANSFERS.BANK_FAIL,
  payload: data,
});


const agentTransfer = (data, history) => ({
  type:   TRANSFERS.AGENT,
  payload: data,
  history
});

const agentTransferSuccess = (data) => ({
  type:   TRANSFERS.AGENT_SUCCESS,
  payload: data,
});

const agentTransferFail = (data) => ({
  type:   TRANSFERS.AGENT_FAIL,
  payload: data,
});

const resolveBank = data => ({
  type: TRANSFERS.RESOLVE_ACCOUNT_NUMBER,
  payload: data
})

const resolveBankSuccess = data => ({
  type: TRANSFERS.RESOLVE_ACCOUNT_NUMBER_SUCCESS,
  payload: data
})

export {
  agentTransfer,
  agentTransferSuccess,
  agentTransferFail,
  resolveBank,
  resolveBankSuccess,
  bankTransfer
};
